/**
 * Free shipping progress bar — progressive enhancement only.
 *
 * The bar is fully computed in Liquid (see snippets/free-shipping-bar.liquid)
 * and therefore already correct in every fragment Dawn re-renders through the
 * Section Rendering API. This script exists purely to animate the fill width
 * from its previous value to the new one after such a re-render, because the
 * replaced node starts life at its final width and would otherwise snap.
 *
 * It must never throw when no bar is present on the page.
 */
(function () {
  if (window.freeShippingBarInitialized) return;
  window.freeShippingBarInitialized = true;

  var SELECTOR = '[data-free-shipping-bar]';
  var lastPercent = {};
  var scheduled = false;

  function animate(bar) {
    if (!bar || typeof bar.querySelector !== 'function') return;

    var fill = bar.querySelector('[data-free-shipping-fill]');
    if (!fill) return;

    var target = parseFloat(bar.getAttribute('data-free-shipping-percent'));
    if (isNaN(target)) return;

    var key = bar.getAttribute('data-free-shipping-bar') || 'default';
    var previous = typeof lastPercent[key] === 'number' ? lastPercent[key] : null;
    lastPercent[key] = target;

    if (previous === null || previous === target) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    fill.style.width = previous + '%';
    // Force a reflow so the browser registers the start value before we
    // transition to the target value.
    void fill.offsetWidth;

    var paint = window.requestAnimationFrame || function (cb) {
      return window.setTimeout(cb, 16);
    };
    paint(function () {
      fill.style.width = target + '%';
    });
  }

  function refresh() {
    scheduled = false;
    var bars;
    try {
      bars = document.querySelectorAll(SELECTOR);
    } catch (error) {
      return;
    }
    for (var i = 0; i < bars.length; i++) animate(bars[i]);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var paint = window.requestAnimationFrame || function (cb) {
      return window.setTimeout(cb, 16);
    };
    paint(refresh);
  }

  function containsBar(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(SELECTOR)) return true;
    return !!(node.querySelector && node.querySelector(SELECTOR));
  }

  function observe() {
    if (typeof MutationObserver !== 'function' || !document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (containsBar(added[j])) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
